import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ControlQuestionService } from '../../services/controlquestion.service';
import { UserSessionService } from '../../services/user-session.service';

interface IntranetSurveyItem {
  recipient_id: number;
  status: string;
  sent_at: string;
  completed_at?: string | null;
  responded_by_name?: string | null;
  title: string;
  description?: string | null;
  link_token: string;
  has_password: boolean;
}

@Component({
  selector: 'app-controlquestion-intranet',
  templateUrl: './controlquestion-intranet.component.html',
  styleUrls: ['./controlquestion-intranet.component.scss']
})
export class ControlquestionIntranetComponent implements OnInit {
  readonly tabs: Array<{ key: 'PENDING' | 'DONE'; label: string }> = [
    { key: 'PENDING', label: 'Pendentes' },
    { key: 'DONE', label: 'Respondidos' }
  ];
  currentUser: any = null;
  loading = false;
  errorMessage = '';
  activeTab: 'PENDING' | 'DONE' = 'PENDING';
  searchTerm = '';
  items: IntranetSurveyItem[] = [];

  constructor(
    private controlquestion: ControlQuestionService,
    private session: UserSessionService,
    private router: Router
  ) {}

  ngOnInit() {
    this.currentUser = this.session.getUser();
    this.loadSurveys();
  }

  loadSurveys() {
    if (!this.currentUser?.tenant_id || !this.currentUser?.id) {
      return;
    }
    this.loading = true;
    this.errorMessage = '';
    this.controlquestion
      .listRecipientSurveys(this.currentUser.tenant_id, this.currentUser.id, this.activeTab)
      .subscribe({
        next: (rows) => {
          this.items = rows || [];
          this.loading = false;
        },
        error: (err) => {
          this.errorMessage = err?.error?.error || 'Não foi possível carregar questionários.';
          this.loading = false;
        }
      });
  }

  setTab(tab: 'PENDING' | 'DONE') {
    if (this.activeTab === tab) {
      return;
    }
    this.activeTab = tab;
    this.searchTerm = '';
    this.loadSurveys();
  }

  get filteredItems(): IntranetSurveyItem[] {
    const term = (this.searchTerm || '').trim().toLowerCase();
    if (!term) {
      return this.items;
    }
    return this.items.filter((item) => {
      const title = String(item.title || '').toLowerCase();
      const description = String(item.description || '').toLowerCase();
      return title.includes(term) || description.includes(term);
    });
  }

  openSurvey(item: IntranetSurveyItem) {
    this.goToSurvey(item);
  }

  goToSurvey(item: IntranetSurveyItem) {
    if (!item || !this.currentUser?.id) {
      return;
    }
    this.router.navigate(['/controlquestion-intranet/respond'], {
      state: {
        token: item.link_token,
        respondent_user_id: this.currentUser.id,
        recipient_id: item.recipient_id,
        autostart: 1,
        read_only: this.activeTab === 'DONE'
      }
    });
  }
}
